(function() {
    'use strict';

    angular.module('allegro').directive('allegroAuth', allegroAuth);

    allegroAuth.$inject = [
        '$q',
        '$interval',
        'checkModelPermissionsSrvc',
        'allegroDataSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigPermissionsConst'
    ];

    function allegroAuth(
        $q, $interval, checkModelPermissionsSrvc, allegroDataSrvc, allegroConfigDataSrvc, allegroConfigPermissionsConst
    ) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/allegro/directives/allegro-auth/allegro-auth.html',
            scope: {
                displayAssociation: '=?',
                authData: '=?',
                onRefresh: '&?'
            },
            link: function(scope, element, attrs, controller) {
                if(scope.displayAssociation === undefined){
                    scope.displayAssociation = false;
                }

                if (scope.authData === undefined){
                    scope.authData = {
                        code_data: null,
                        access_token_data: null,
                    };
                }

                scope.intervalPromise = null;
                scope.authLoading = true;
                scope.configurationCount = 0;

                scope.getAllegroConfigList = getAllegroConfigList;
                scope.isConfigurationFilled = isConfigurationFilled;
                scope.getAuthInfo = getAuthInfo;
                scope.refreshAuthInfo = refreshAuthInfo;
                scope.getDeviceCode = getDeviceCode;
                scope.revokeToken = revokeToken;
                scope.hasAssociationPermissions = hasAssociationPermissions;
                scope.hasRevokeTokenPermissions = hasRevokeTokenPermissions;

                onInit();
                function onInit(){
                    $q.all([
                        scope.getAllegroConfigList(),
                        scope.getAuthInfo()
                    ]).then(
                        function(){
                            scope.authLoading = false;
                        }
                    );
                }

                function getAllegroConfigList(){
                    return allegroConfigDataSrvc.list().$promise.then(
                        function (response) {
                            scope.configurationCount = response.count;
                            return response;
                        }
                    )
                }

                function isConfigurationFilled(){
                    return scope.configurationCount > 0
                }

                function getAuthInfo(){
                    return allegroConfigDataSrvc.getAuthInfo().$promise.then(
                        function (response) {
                            scope.authData = response;
                            scope.authLoading = false;

                            if (scope.intervalPromise !== null && scope.authData.code_data === null){
                                $interval.cancel(scope.intervalPromise);

                                if(scope.onRefresh){
                                    scope.onRefresh();
                                }
                            }
                            return response;
                        }
                    )
                }

                function refreshAuthInfo(timeoutTime){
                    scope.intervalPromise = $interval(function() {
                        scope.getAuthInfo();
                        }, timeoutTime
                    );
                }

                function getDeviceCode(){
                    allegroConfigDataSrvc.getDeviceCode().$promise.then(
                        function (response) {
                            scope.authData.code_data = response;
                            scope.refreshAuthInfo(5000);
                            return response;
                        }
                    )
                }

                function revokeToken(){
                    allegroConfigDataSrvc.revokeToken().$promise.then(
                        function (response) {
                            if (response.is_revoked){
                                scope.authData.access_token_data = null;
                            }
                            return response;
                        }
                    )
                }

                function hasAssociationPermissions() {
                    return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.update);
                }

                function hasRevokeTokenPermissions() {
                    return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.delete);
                }
            }
        };
    }
})();
